// extracted by mini-css-extract-plugin
var _1 = "CarouselThumbnailDragPreview-module__preview--CkfKZ";
var _2 = "CarouselThumbnailDragPreview-module__previewContainer--f0Z70";
export { _1 as "preview", _2 as "previewContainer" }
